import {QueryHookOptions, gql, useLazyQuery, useQuery} from "@apollo/client";

import {Location} from "../../locations";
import {API_CLIENT} from "../client";

export type MonolithLocationFields = Pick<
  Location,
  | "address"
  | "coverImageId"
  | "googlePlaceId"
  | "hours"
  | "id"
  | "locationSpecialties"
  | "name"
  | "phoneNumber"
  | "practiceId"
  | "region"
  | "slug"
  | "specialtyIds"
  | "timezone"
>;

export type LocationQuery = {
  location: MonolithLocationFields;
};

export type LocationQueryVariables = {
  slug: string;
};

export const GET_LOCATION_BY_SLUG = gql`
  query GetLocation($slug: String) {
    location(slug: $slug)
      @rest(type: "Location", endpoint: "monolith", path: "/hib/locations/bySlug/{args.slug}") {
      address
      coverImageId
      googlePlaceId
      hours
      id
      locationSpecialties
      name
      phoneNumber
      practiceId
      region
      slug
      specialtyIds
      timezone
    }
  }
`;

export const useMonolithLocationFieldsBySlugQuery = (
  slug: string | null,
  {skip, ...options}: QueryHookOptions<LocationQuery, LocationQueryVariables> = {},
) =>
  useQuery<LocationQuery, LocationQueryVariables>(GET_LOCATION_BY_SLUG, {
    variables: {
      slug: slug || "",
    },
    context: {
      clientName: API_CLIENT,
    },
    skip: !slug || skip,
    ...options,
  });

export const useLazyMonolithLocationFieldsBySlugQuery = () =>
  useLazyQuery<LocationQuery, LocationQueryVariables>(GET_LOCATION_BY_SLUG, {
    context: {
      clientName: API_CLIENT,
    },
  });
